import styles from './styles.module.scss';

type Icon = {
  id?: string,
  iconName: string,
  color?: string,
  useOutlined?: boolean,
  className?: string,
  children?: JSX.Element,
  onClick?: () => void;
}

function Icon(props : Icon) : JSX.Element {
  const extraClass = props.className ? ` ${props.className}` : '';
  const style = { color : props.color };

  const onClick = () : void => {
    if (props.onClick !== undefined)
      props.onClick();
  };

  return (
    <span
      id={props.id || ''}
      onClick={onClick}
      style={style}
      className={`${props.useOutlined ? 'material-icons-outlined' : 'material-icons' } ${styles['biobar-icon']}${extraClass}`}>
      {props.iconName}
      {props.children}
    </span>
  );
}

export default Icon;